import { LS2PAC_CONSTANTS } from "../../../../../../js/main/constants";
import { BaseDetailView } from "../BaseDetailView";

export class Ebsco_Details extends BaseDetailView {
  constructor(options) {
    options = options || {};

    options.resultsTemplate = "tmpl/details/ebsco/details.html";
    options.parentId = LS2PAC_CONSTANTS.Ids.DetailsPage.ebscoDetailsContainer;

    super(options);

    this.addListeners();
  }
  load(resourceData, index, viewName) {
    var _this = this;

    this.parentClass.updatePagingControls();
  }
  addEvents() {
    if (this.hasBoundEvents == false) {
      this.hasBoundEvents = true;
    }
  }
  addListeners() {
    var _this = this;
  }
}
